import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  CreateBclProductRequestDto,
  CreateBclProductResponseDto
} from "../../dtos/bcl-product-dto";
import { ProductService } from "../../services/product-service";

type UsePutUpdateBclProductMutationParams = {
  options?: UseMutationOptions<
    CreateBclProductResponseDto,
    unknown,
    CreateBclProductRequestDto & { productId: string }
  >;
};

export const usePutUpdateBclProductMutation = ({
  options
}: UsePutUpdateBclProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.updateBclProduct({ payload });
    },
    ...options
  });
};
